import useClientLogoImages from "./useClientLogoImages"
import CLIENT_LOGOS from "../../data/clientLogos"

/**
 * The one place src/data/clientLogos.js's file paths are turned into real
 * images — every consumer (the homepage/About Us marquee, every industry
 * Trusted By section, the /caseStudies story cards) reads from this
 * instead of resolving colorFile/grayFile against useClientLogoImages()
 * itself, so there's one lookup to get right, not four.
 *
 * Returns every client, each with its data from clientLogos.js plus
 * `colorImage`/`grayImage` (`{ width, height, fluid }`, or null if that
 * client has no file on that side) and `logoImage` (grayImage || colorImage
 * — a quick "does this client have any logo at all" check). Colour is
 * never shown from here: every consumer reads `grayImage` first and only
 * falls back to `colorImage` (CSS-grayscale-filtered) when there's no grey
 * file yet — see ClientLogoBox.js, TrustedBy.js and AllCaseStudiesPage.js.
 * The one place real colour shows is each individual case study's own
 * page, which imports its Colored/ file directly and doesn't use this hook
 * at all.
 */
const useClientLogos = () => {
  const images = useClientLogoImages()

  return CLIENT_LOGOS.map(client => {
    const colorImage = client.colorFile ? images[client.colorFile] || null : null
    const grayImage = client.grayFile ? images[client.grayFile] || null : null
    return {
      ...client,
      colorImage,
      grayImage,
      logoImage: grayImage || colorImage,
    }
  })
}

export default useClientLogos
